import "./style.css";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import gsap from "gsap";
import * as dat from "dat.gui";
import firefliesVertexShader from "./shaders/fireflies/vertex.glsl";
import firefliesFragmentShader from "./shaders/fireflies/fragment.glsl";
import rgbVertexShader from "./shaders/rgb/vertex.glsl";
import rgbFragmentShader from "./shaders/rgb/fragment.glsl";
import { Vector2 } from "three";

import { water2, wireframe2 } from "./water.js";

// Debug

const mouse = new THREE.Vector2();
const target = new THREE.Vector2();
// Scene
const scene = new THREE.Scene();

// Fog

{
  const near = 1;
  const far = 7;
  const color = "#012b43";
  scene.fog = new THREE.Fog(color, near, far);
  scene.background = new THREE.Color(color);
}

// Models

const gltfLoader = new GLTFLoader();

let landscape3 = new THREE.Object3D();
let ufo = new THREE.Object3D();
let ufo2 = new THREE.Object3D();

let mixer = null;

gltfLoader.load("/models/landscape3.gltf", (gltf) => {
  gltf.scene.scale.set(0.025, 0.025, 0.025);
  gltf.scene.position.set(0, -0.2, 0.65);
  gltf.scene.rotation.set(0.3, 0.3, 0);
  scene.add(gltf.scene);

  landscape3 = gltf.scene;

  scene.add(landscape3);
});

gltfLoader.load("/models/ufo3.glb", (gltf) => {
  gltf.scene.scale.set(0.025, 0.025, 0.025);
  gltf.scene.position.set(0, -1, 0);

  ufo = gltf.scene;

  scene.add(ufo);
});

gltfLoader.load("/models/ufo3.glb", (gltf) => {
  gltf.scene.scale.set(0.025, 0.025, 0.025);
  gltf.scene.position.set(-5, -3.5, 6);
  gltf.scene.rotation.set(0.3, 0, 0);

  ufo2 = gltf.scene;

  scene.add(ufo2);
});

// Fireflies
// Geometry
const firefliesGeometry = new THREE.BufferGeometry();
const firefliesCount = 8000;
const positionArray = new Float32Array(firefliesCount * 3);
const positionArray2 = new Float32Array();
const scaleArray = new Float32Array(firefliesCount);

for (let i = 0; i < firefliesCount; i++) {
  positionArray[i * 3 + 0] = (Math.random() - 0.5) * 25;

  positionArray[i * 3 + 1] = (Math.random() - 0.2) * 50;
  positionArray[i * 3 + 2] = (Math.random() - 0.5) * 15;

  scaleArray[i] = Math.random();
}

firefliesGeometry.setAttribute(
  "position",
  new THREE.BufferAttribute(positionArray, 3)
);
firefliesGeometry.setAttribute(
  "aScale",
  new THREE.BufferAttribute(scaleArray, 1)
);

firefliesGeometry.setAttribute(
  "position",
  new THREE.BufferAttribute(positionArray, 3)
);

//Firefly Material
const firefliesMaterial = new THREE.ShaderMaterial({
  uniforms: {
    uTime: { value: 0 },
    uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
    uSize: { value: 50 },
  },
  vertexShader: firefliesVertexShader,
  fragmentShader: firefliesFragmentShader,
  transparent: true,
  blending: THREE.AdditiveBlending,
  depthWrite: false,
});

// gui
//   .add(firefliesMaterial.uniforms.uSize, "value")
//   .min(1)
//   .max(500)
//   .step(1)about / contact
//   .name("firefliesSize");

//Firefly Points
const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial);
fireflies.position.z = 1;
fireflies.position.y = -0.5;
scene.add(fireflies);

console.log(positionArray);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.8);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
directionalLight.castShadow = false;

directionalLight.position.set(5, 5, 5);
scene.add(directionalLight);

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Textures
let texture = new THREE.TextureLoader().load("/textures/FbStart_thumb.jpg");
let texture2 = new THREE.TextureLoader().load("/textures/BoxTrolls_thumb.jpg");
let texture3 = new THREE.TextureLoader().load(
  "/textures/amazon_huddles_thumb.jpg"
);
let texture4 = new THREE.TextureLoader().load(
  "/textures/nikeAbstract_thumb.jpg"
);

let texture5 = new THREE.TextureLoader().load("/textures/Fox_Sports_thumb.jpg");

let texture6 = new THREE.TextureLoader().load("/textures/IbmWeb_thumb.jpg");

let texture7 = new THREE.TextureLoader().load("/textures/Paranorman_thumb.jpg");
let texture8 = new THREE.TextureLoader().load(
  "/textures/Nissan_Holiday_Spirit_Everyone_thumb.jpg"
);
let texture9 = new THREE.TextureLoader().load("/textures/reactPillows.jpg");

let texture10 = new THREE.TextureLoader().load("/textures/KIA_thumb.jpg");
let texture11 = new THREE.TextureLoader().load("/textures/Kroger_Digital.jpg");
let texture12 = new THREE.TextureLoader().load(
  "/textures/origin_genomics_thumb.jpg"
);
let texture13 = new THREE.TextureLoader().load(
  "/textures/HouseSpecial_Kroger_thumb.jpg"
);
let texture14 = new THREE.TextureLoader().load("/textures/BTeam_thumb.jpg");
let texture15 = new THREE.TextureLoader().load(
  "/textures/safetyDemo_thumb.jpg"
);
let texture16 = new THREE.TextureLoader().load(
  "/textures/Oxfam_Americ_thumb.jpg"
);
let texture17 = new THREE.TextureLoader().load(
  "/textures/VerizonAnthem_thumb.jpg"
);
let texture18 = new THREE.TextureLoader().load(
  "/textures/track_town_thumb.jpg"
);
let texture19 = new THREE.TextureLoader().load("/textures/planters_thumb.jpg");
let texture20 = new THREE.TextureLoader().load(
  "/textures/LAIKA_TRU2011_N2D1_Generic_web_thumb.jpg"
);

let texture21 = new THREE.TextureLoader().load("/textures/portfolio-text.jpg");
// immediately use the texture for material creation

const sizes2 = new THREE.Vector2(2, 1.5); // Mesh size
const offSet = new Vector2(0, 0); // Mesh position
const offSet2 = new Vector2(0, 0); // Mesh position
const planeGeometry = new THREE.PlaneGeometry(1.2, 0.7, 5, 5);
const planeGeometryText = new THREE.PlaneGeometry(2.5, 1.5, 1, 1);

const material1 = new THREE.ShaderMaterial({
  uniforms: {
    time: { value: 1.0 },
    uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },

    uTexture: { value: texture },
    uCorners: { value: new THREE.Vector4(1, 1, 1, 1) },
    uResolution: { value: new THREE.Vector2(1200, 1200) },

    uProgress: { value: 0.0 },
    uOffset: { value: new THREE.Vector2(0.0, 0.0) },
    uOffsetG: { value: new THREE.Vector2(0.0, 0.0) },
    scaleX: { type: "f", value: 1.0 },
    scaleY: { type: "f", value: 1.0 },
    scaleZ: { type: "f", value: 1.0 },
  },
  vertexShader: rgbVertexShader,
  fragmentShader: rgbFragmentShader,
  side: THREE.DoubleSide,
  wireframe: false,
});

let material2 = material1.clone();
material2.uniforms.uTexture.value = texture2;

let material3 = material1.clone();
material3.uniforms.uTexture.value = texture3;

let material4 = material1.clone();
material4.uniforms.uTexture.value = texture4;

let material5 = material1.clone();
material5.uniforms.uTexture.value = texture5;

let material6 = material1.clone();
material6.uniforms.uTexture.value = texture6;

let material7 = material1.clone();
material7.uniforms.uTexture.value = texture7;

let material8 = material1.clone();
material8.uniforms.uTexture.value = texture8;

let material9 = material1.clone();
material9.uniforms.uTexture.value = texture9;

let material10 = material1.clone();
material10.uniforms.uTexture.value = texture10;

let material11 = material1.clone();
material11.uniforms.uTexture.value = texture11;

let material12 = material1.clone();
material12.uniforms.uTexture.value = texture12;

let material13 = material1.clone();
material13.uniforms.uTexture.value = texture13;

let material14 = material1.clone();
material14.uniforms.uTexture.value = texture14;

let material15 = material1.clone();
material15.uniforms.uTexture.value = texture15;

let material16 = material1.clone();
material16.uniforms.uTexture.value = texture16;

let material17 = material1.clone();
material17.uniforms.uTexture.value = texture17;

let material18 = material1.clone();
material18.uniforms.uTexture.value = texture18;

let material19 = material1.clone();
material19.uniforms.uTexture.value = texture19;

let material20 = material1.clone();
material20.uniforms.uTexture.value = texture20;

let material21 = material1.clone();
material21.uniforms.uTexture.value = texture21;
material21.depthTest = true;
material21.depthWrite = true;
material21.transparent = true;
material21.blending = THREE.CustomBlending;
material21.blendEquation = THREE.MaxEquation;
material21.blendSrc = THREE.SrcAlphaFactor;
material21.blendDst = THREE.OneMinusSrcAlphaFactor;
material21.uniforms.uOffsetG.value = [0.0, 0.0];
const plane1 = new THREE.Mesh(planeGeometry, material1);
plane1.name = "plane1";
const plane2 = new THREE.Mesh(planeGeometry, material2);
const plane3 = new THREE.Mesh(planeGeometry, material3);

const plane4 = new THREE.Mesh(planeGeometry, material4);

const plane5 = new THREE.Mesh(planeGeometry, material5);
const plane6 = new THREE.Mesh(planeGeometry, material6);
const plane7 = new THREE.Mesh(planeGeometry, material7);
const plane8 = new THREE.Mesh(planeGeometry, material8);
const plane9 = new THREE.Mesh(planeGeometry, material9);
const plane10 = new THREE.Mesh(planeGeometry, material10);
const plane11 = new THREE.Mesh(planeGeometry, material11);
const plane12 = new THREE.Mesh(planeGeometry, material12);
const plane13 = new THREE.Mesh(planeGeometry, material13);
const plane14 = new THREE.Mesh(planeGeometry, material14);
const plane15 = new THREE.Mesh(planeGeometry, material15);
const plane16 = new THREE.Mesh(planeGeometry, material16);
const plane17 = new THREE.Mesh(planeGeometry, material17);
const plane18 = new THREE.Mesh(planeGeometry, material18);
const plane19 = new THREE.Mesh(planeGeometry, material19);
const plane20 = new THREE.Mesh(planeGeometry, material20);
const plane21 = new THREE.Mesh(planeGeometryText, material21);

scene.add(plane1);

scene.add(plane2);

scene.add(plane3);

scene.add(plane4);

plane5.name = "plane5";

scene.add(plane5);

plane6.name = "plane6";

scene.add(plane6);
scene.add(plane7);
scene.add(plane8);
scene.add(plane9);
scene.add(plane10);
scene.add(plane11);
scene.add(plane12);
scene.add(plane13);
scene.add(plane14);
scene.add(plane15);
scene.add(plane16);
scene.add(plane17);
scene.add(plane18);
scene.add(plane19);
scene.add(plane20);
scene.add(plane21);

let planeArr = [
  [plane1, plane2, plane3, plane4, plane5],
  [plane6, plane7, plane8, plane9, plane10],
  [plane11, plane12, plane13, plane14, plane15],
  [plane16, plane17, plane18, plane19, plane20],
];
let pos = -2.4;
let pos2 = -2.4;
let pos3 = -2.4;
let pos4 = -2.4;
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

const planePos = () => {
  planeArr[0].forEach((plane) => {
    pos++;
    plane.position.y = pos - 2;
    plane.position.z = 4;
    plane.position.x += getRandomInt(-1.0, 2.0);
    console.log(planeArr[0][2]);
  });
  planeArr[1].forEach((plane) => {
    pos2++;
    plane.position.y = pos2 - 4;
    plane.position.z = 4;
    plane.position.x += getRandomInt(-1.0, 2.0);
  });
  planeArr[2].forEach((plane) => {
    pos3++;
    plane.position.y = pos3 - 6;
    plane.position.z = 4;
    plane.position.x += getRandomInt(-1.0, 2.0);
  });
  planeArr[3].forEach((plane) => {
    pos4++;
    plane.position.y = pos4 - 8;
    plane.position.z = 4;
    plane.position.x += getRandomInt(-1.0, 2.0);
  });
};

plane1.position.set(2, -0.6, 4);
plane1.rotation.set(0, 0, 0);
plane2.position.set(0.3, -0.2, 4);
plane3.position.set(-1.5, -0.5, 4);
plane3.rotation.set(0, 0, 0);
plane4.position.set(-1, -1.5, 4);
plane5.position.set(1, -1.5, 4);
plane6.position.set(-0.3, -2.5, 4);
plane7.position.set(0, -3.6, 4);
plane8.position.set(0.3, -4.8, 4);
plane9.position.set(-0.3, -6, 4);
plane10.position.set(0.7, -7, 4);
plane11.position.set(0.7, -8, 4);
plane12.position.set(0, -9, 4);
plane13.position.set(1, -10, 4);
plane14.position.set(0, -11, 4);
plane15.position.set(-1, -12, 4);
plane16.position.set(1, -13, 4);
plane17.position.set(-0.3, -14, 4);
plane18.position.set(0, -15, 4);
plane19.position.set(-1.9, -14.3, 4);
plane20.position.set(2, -14.5, 4);
plane21.position.set(0, 0.5, 4.5);

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

const thumbGroup = new THREE.Group();
thumbGroup.add(plane1);
thumbGroup.add(plane2);
thumbGroup.add(plane3);
thumbGroup.add(plane4);
thumbGroup.add(plane5);
thumbGroup.add(plane6);
thumbGroup.add(plane7);
thumbGroup.add(plane8);
thumbGroup.add(plane9);
thumbGroup.add(plane10);
thumbGroup.add(plane11);
thumbGroup.add(plane12);
thumbGroup.add(plane13);
thumbGroup.add(plane14);
thumbGroup.add(plane15);
thumbGroup.add(plane16);
thumbGroup.add(plane17);
thumbGroup.add(plane18);
thumbGroup.add(plane19);
thumbGroup.add(plane20);

scene.add(thumbGroup);

thumbGroup.position.y = -0.5;

console.log(sizes);
console.log(planeArr[0][4].position);
window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  document.body.appendChild(renderer.domElement);
  // Update fireflies
  firefliesMaterial.uniforms.uPixelRatio.value = Math.min(
    window.devicePixelRatio,
    2
  );
});

let raycaster = new THREE.Raycaster();
let currentIntersect = null;

// Camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  500
);
camera.position.z = 6;
camera.position.y = 1;
scene.add(camera);
scene.add(wireframe2);
scene.add(water2);
console.log(camera);

// Renderer
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

window.addEventListener("mousemove", (event) => {
  mouse.x = (event.clientX / sizes.width) * 2 - 1;
  mouse.y = -(event.clientY / sizes.height) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);

  const objectsToTest = [
    plane1,
    plane2,
    plane3,
    plane4,
    plane5,
    plane6,
    plane7,
    plane8,
    plane9,
    plane10,
    plane11,
    plane12,
    plane13,
    plane14,
    plane15,
    plane16,
    plane17,
    plane18,
    plane19,
    plane20,
  ];
  const intersects = raycaster.intersectObjects(objectsToTest);

  if (intersects.length) {
    if (!currentIntersect) {
      gsap.to(intersects[0].object.scale, {
        duration: 1,
        delay: 0,
        repeat: 0,

        z: 1,
        x: 1.2,
        y: 1.2,

        ease: "expo.out",
      });

      if (mouse.x < 0) {
        gsap.to(intersects[0].object.rotation, {
          duration: 1,
          delay: 0,
          repeat: 0,

          y: 0.2,

          ease: "expo.out",
        });
      }

      if (mouse.x > 0) {
        gsap.to(intersects[0].object.rotation, {
          duration: 1,
          delay: 0,
          repeat: 0,

          y: -0.2,

          ease: "expo.out",
        });
      }
    }
    currentIntersect = intersects[0];
  } else {
    if (currentIntersect) {
      console.log("mouse leave");
      console.log(currentIntersect.object);
      gsap.to(currentIntersect.object.scale, {
        duration: 1,
        delay: 0,
        repeat: 0,

        z: 1,
        x: 1,
        y: 1,

        ease: "expo.out",
      });
      gsap.to(currentIntersect.object.rotation, {
        duration: 1,
        delay: 0,
        repeat: 0,

        y: 0,

        ease: "power2.out",
      });
    }

    currentIntersect = null;
  }
});
console.log(currentIntersect);

camera.updateMatrixWorld();

let clicked = false;
let toggle = () => {
  clicked = clicked ? false : true;
};

let clicked2 = false;
let toggle2 = () => {
  clicked2 = clicked2 ? false : true;
};

var images_modal = document.getElementById("myModal");
var images_modalContact = document.getElementById("myModalContact");

// When the user clicks anywhere outside of the modal, close it
function stopVideo() {
  videocontainer.pause();
  videocontainer.currentTime = 0;
}
window.onclick = function (event) {
  if (event.target == images_modal) {
    images_modal.style.display = "none";
    stopVideo();
  }
  if (event.target == images_modalContact) {
    images_modalContact.style.display = "none";
    contactButton.innerHTML = "about / contact";

    gsap.to(camera.position, {
      z: 6,
      duration: 1,
      ease: "power3.inOut",
    });
    clicked = false;
  }
};

let contactButton = document.getElementById("contact");
const contact = (event) => {
  contactButton.addEventListener("click", function (event) {
    currentIntersect = null;
    toggle();
    clicked2 = false;
    clicked
      ? (contactButton.innerHTML = "back")
      : (contactButton.innerHTML = "about / contact");
    console.log(clicked);
    clicked
      ? gsap.to(camera.position, {
          z: -3,
          duration: 1,
          ease: "power3.inOut",
        })
      : gsap.to(camera.position, {
          z: 6,
          duration: 1,
          ease: "power3.inOut",
        });

    if (clicked) {
      modalsContact();
      let video = document.getElementById("myModal");
      video.style.display = "none";
      function stopVideo() {
        videocontainer.pause();
        videocontainer.currentTime = 0;
      }

      images_modal.style.display = "none";
      stopVideo();
    }
    if (!clicked) {
      images_modalContact.style.display = "none";
    }
  });
};
contact();
let modals = () => {
  var modal = document.getElementById("myModal");
  modal.style.display = "block";

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  // When the user clicks on <span> (x), close the modal
  var modalEdge = document.getElementsByClassName(
    "w3-modal-content w3-animate-zoom w3-card-3"
  )[0];
  var video = document.getElementById("videoclip");

  function stopVideo() {
    videocontainer.pause();
    videocontainer.currentTime = 0;
  }

  span.onclick = function () {
    stopVideo();
    modal.style.display = "none";
  };
  modalEdge.onclick = function () {
    stopVideo();
    modal.style.display = "none";
  };
};
//Contact modal
let modalsContact = () => {
  var modal = document.getElementById("myModalContact");
  modal.style.display = "block";

  var spanContact = document.getElementsByClassName("closeContact")[0];

  spanContact.onclick = function () {
    modal.style.display = "none";
    contactButton.innerHTML = "about / contact";
    gsap.to(camera.position, {
      keyframes: [{ z: 6, duration: 1, ease: "power3.inOut" }],
    });
    clicked = false;
  };
};
console.log(currentIntersect);

var videocontainer = document.getElementById("videoclip");
var videosource = document.getElementById("mp4video");
var newmp4 = "/videos/FbStartBright_video_V9_ym7azq.mp4";
var newmp42 = "/videos/boxtrolls_uwlqcu.mp4";
var newmp43 = "/videos/Huddle_PushPull_Blue_2021web_tfga7a.mp4";
var newmp44 = "/videos/FA18_RN_React_3DAbstract_v007W_web_a518dl.mp4";
var newmp45 = "/videos/Fox_Sports_web_pcxuaz.mp4";
var newmp46 = "/videos/IbmWeb2_nyae84.mp4";
var newmp47 = "/videos/ParanormanCredits_web2_khcvtx.mp4";
var newmp48 = "/videos/Nissan_Holiday_Spirit_Everyone_web_skw91k.mp4";
var newmp49 = "/videos/FA18_RN_React_Pillows_v007W2_p7zel9.mp4";
var newmp410 = "/videos/KIA_web_bz95z7.mp4";
var newmp411 = "/videos/Kroger_Digital_Engagement_hhp9zg.mp4";
var newmp412 = "/videos/origin_genomics_web_bwwxoj.mp4";
var newmp413 = "/videos/HouseSpecial_Kroger_Refresh_cc6bxq.mp4";
var newmp414 = "/videos/BTeam_web2_djtyoc.mp4";
var newmp415 = "/videos/Toyota_safetyDemo_web_h1uwff.mp4";
var newmp416 = "/videos/Oxfam_GiftBetter_obv985.mp4";
var newmp417 = "/videos/VerizonAnthem_web2_fsion9.mp4";
var newmp418 = "/videos/track_town_web2_vyb4oo.mp4";
var newmp419 = "/videos/planters_afur4u.mp4";
var newmp420 = "/videos/LAIKA_TRU2011_N2D1_Generic_web_d5gffx.mp4";

window.addEventListener("click", () => {
  var title = document.getElementById("title");
  var desc = document.getElementById("desc");
  if (currentIntersect) {
    switch (currentIntersect.object) {
      case plane1:
        modals();

        title.innerHTML = "FACEBOOK START";
        desc.innerHTML = "Animation / effects";
        videosource.setAttribute("src", newmp4);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        console.log(plane1.position.z);

        console.log("clicked on object1");
        break;

      case plane2:
        console.log("clicked on object2");
        modals();

        title.innerHTML = "BOXTROLLS";

        desc.innerHTML = "Animation / comp of all elements";
        videosource.setAttribute("src", newmp42);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane3:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "AMAZON";

        desc.innerHTML = "Animation / comp of all elements";
        videosource.setAttribute("src", newmp43);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane4:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "NIKE ABSTRACT";

        desc.innerHTML = "Animation / comp of all elements";
        videosource.setAttribute("src", newmp44);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane5:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "FOX SPORTS";

        desc.innerHTML = "Lighting / particle effects";
        videosource.setAttribute("src", newmp45);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane6:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "IBM THINK";

        desc.innerHTML = "Animation / modeling / effects";
        videosource.setAttribute("src", newmp46);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane7:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "PARANORMAN CREDITS";

        desc.innerHTML = "Animation / comp of all elements";
        videosource.setAttribute("src", newmp47);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane8:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "NISSAN HOLIDAY SPIRIT";

        desc.innerHTML = "Coloring / comp of all elements";
        videosource.setAttribute("src", newmp48);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane9:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "NIKE PILLOWS";

        desc.innerHTML = "Animation / effects";
        videosource.setAttribute("src", newmp49);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane10:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "KIA BLAZERS";

        desc.innerHTML = "Animation / comp of all elements";
        videosource.setAttribute("src", newmp410);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane11:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "KROGER";

        desc.innerHTML = "Animation / effects / comp of all elements";
        videosource.setAttribute("src", newmp411);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane12:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "ORIGIN GENOMICS";

        desc.innerHTML = "Animation / effects / comp of all elements";
        videosource.setAttribute("src", newmp412);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane13:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "KROGER";

        desc.innerHTML = "Animation / effects / comp of all elements";
        videosource.setAttribute("src", newmp413);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane14:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "B-TEAM";

        desc.innerHTML = "Animation / effects / comp of all elements";
        videosource.setAttribute("src", newmp414);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane15:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "TOYOTA";

        desc.innerHTML = "Particle effects / comp";
        videosource.setAttribute("src", newmp415);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane16:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "OXFAM AMERICA";

        desc.innerHTML =
          "Asset creation / comp / animation of secondary elements";
        videosource.setAttribute("src", newmp416);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane17:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "VERIZON ANTHEM";

        desc.innerHTML = "Animation / asset creation / comp of all elements";
        videosource.setAttribute("src", newmp417);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane18:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "NIKE TRACKTOWN VISUALIZATION";

        desc.innerHTML = "Animation / asset creation / comp of all elements";
        videosource.setAttribute("src", newmp418);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane19:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "PLANTERS";

        desc.innerHTML = "Animation / comp of all cg elements";
        videosource.setAttribute("src", newmp419);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
      case plane20:
        console.log("clicked on object3");
        modals();

        title.innerHTML = "TOYS R US";

        desc.innerHTML = "Animation / comp of all cg elements";
        videosource.setAttribute("src", newmp420);
        videocontainer.load();
        console.log(videosource);
        videocontainer.play();

        break;
    }
  }
});

const clock = new THREE.Clock();

let y = 0;
let position = 0;

window.addEventListener("wheel", onMouseWheel);

let scrollPosition = 0;
let scrollTarget = 0;

let current = 0;
let target3 = 0;
let ease = 0.075;

function onMouseWheel(event) {
  scrollTarget = event.deltaY * 0.0007;
}

console.log(camera.position.y);
function lerp(start, end, t) {
  return start * (1 - t) + end * t;
}
let scrollY = window.scrollY;
window.addEventListener("scroll", () => {
  scrollY = window.scrollY;
});

let previousTime = 0;

const tick = () => {
  let ease = 0.3;
  let ease2 = 0.00025;
  scrollPosition *=
    lerp(window.scrollY / sizes.height, window.scrollY, ease) * 0.0055;
  // console.log(mouse.y);
  const elapsedTime = clock.getElapsedTime();
  // Scroll
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  let picDistort = (-scrollY * 0.003 - camera.position.y) * 2 * deltaTime;

  camera.position.y += (-scrollY * 0.003 - camera.position.y) * 4 * deltaTime;

  target.x = mouse.x * 0.08;
  target.y = mouse.y * 0.08;

  material1.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material2.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material3.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material4.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material5.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material6.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material7.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material8.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material9.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material10.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material11.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material12.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material13.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material14.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material15.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material16.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material17.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material18.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material19.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );
  material20.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.3,

    picDistort
  );

  material21.uniforms.uOffset.value.set(
    (target.x - offSet.x) * 0.1,

    picDistort
  );

  ufo2.rotation.y += -picDistort * 1.7;
  ufo2.rotation.x -= -picDistort * 0.2;
  ufo2.position.x += -picDistort * 1.7;
  ufo2.position.y += picDistort * 1.5;
  ufo2.position.z += picDistort * 1.35;

  camera.rotation.x += 0.1 * (target.y - camera.rotation.x);
  camera.rotation.y += 0.1 * (target.x - camera.rotation.y);
  renderer.render(scene, camera);

  const ufoAngle = -elapsedTime * 0.18;
  ufo.position.y = Math.sin(elapsedTime);
  ufo.position.x = Math.cos(ufoAngle) * (7 + Math.sin(elapsedTime * 0.32));
  ufo.position.z = Math.sin(ufoAngle) * (8 + Math.sin(elapsedTime * 0.5));
  ufo.rotation.y = elapsedTime;

  // Update materials
  firefliesMaterial.uniforms.uTime.value = elapsedTime;

  window.requestAnimationFrame(tick);
};

tick();
